/*
    * Handle Forms
    * This file handles all forms on the website.
    * It uses AJAX to send data to the server and get a response.
    * It also handles the response and displays it to the user.
*/

import { data } from 'jquery';
import { icons } from './icons';
import { select2 } from 'select2';
import { select2css } from 'select2/dist/css/select2.css';

var formChanges = false

export default function handleForms() {
    jQuery('#create-period').on('input change', function() {
        formChanges = true;
    });

    jQuery('.update-user').on('input change', function() {
        formChanges = true;
    });

    jQuery(window).on('beforeunload', function(e) {
        if (!formChanges) {
            return;
        }
        var message = 'Du har inte sparat dina ändringar. Är du säker på att du vill lämna sidan?';
        e.preventDefault();
        e.returnValue = message;
        return message;
    });

    /**
     * Update profile
     */
    jQuery(".update-user").submit(function (e) {
        formChanges = false;
        e.preventDefault();

        let form = jQuery(this);
        let modal = jQuery(this).closest(".storeeez-modals");
        let buttonHtml = jQuery(form).find("button").html();
        let refresh = jQuery(this).data("refresh") ? true : false;

        let data = {
            action: 'update_user',
            first_name: jQuery(form).find("input[name='first_name']").val(),
            last_name: jQuery(form).find("input[name='last_name']").val(),
            email: jQuery(form).find("input[name='email']").val(),
            billing: {
                company: jQuery(form).find("input[name='company']").val(),
                postcode: jQuery(form).find("input[name='zip']").val(),
                address_1: jQuery(form).find("input[name='address']").val(),
                city: jQuery(form).find("input[name='city']").val(),
                phone: jQuery(form).find("input[name='phone']").val(),
                email: jQuery(form).find("input[name='email']").val(),
            },
            shipping: {
                phone: jQuery(form).find("input[name='phone']").val(),
            }
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.status == "success") {
                    /* Success Message */
                    hideModal(modal, resetModal);
                    jQuery(form).removeClass("opacity-50 pointer-events-none").find("button").removeClass("!bg-transparent").html(buttonHtml);

                    if (refresh) {
                        // location.reload();
                    }
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
     * Create new seller
     */

    jQuery(".create-new-seller").submit(function (e) {

        e.preventDefault();

        let form = jQuery(this);
        let modal = jQuery(this).closest(".storeeez-modals");
        let buttonHtml = jQuery(form).find("button").html();
        let refresh = jQuery(this).data("refresh") ? true : false;

        let data = {
            action: 'add_influencer',
            name: jQuery(form).find("input[name='name']").val(),
            email: jQuery(form).find("input[name='email']").val(),
            phonenumber: jQuery(form).find("input[name='phonenumber']").val(),
            sales_periods: jQuery(form).find("select[name='sales_periods']").val() ?? jQuery(form).find("input[name='sales_periods']").val()
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.status == "success") {
                    /* Success Message */
                    hideModal(modal, resetModal);
                    jQuery(form).removeClass("opacity-50 pointer-events-none").find("button").removeClass("!bg-transparent").html(buttonHtml);
                    if (refresh) {
                        location.reload();
                    }
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
     * Update single influencer
     */

    jQuery(".edit-single-seller").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);

        let confirm_password = jQuery(form).find("input[name='confirm_password']").val();

        /* Check if passwords match */
        if(jQuery(form).find("input[name='password']").val() != "") {
            if (jQuery(form).find("input[name='password']").val() != confirm_password) {
                jQuery(form).find(".error-holder").each(function () {
                    jQuery(this).find(".no-match-error").removeClass("hidden");
                });
                return;

            }
        }

        let data = {
            action: 'update_single_influencer',
            password: jQuery(form).find("input[name='password']").val(),
            email: jQuery(form).find("input[name='email']").val()
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.status == "success") {
                    jQuery("body").addClass("modal-handled");

                    /* Success Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">` + (response.button_text) + `</a>
                        </div>
                    </div>
                    `);
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
     * Update influencer
     */

    jQuery(".edit-seller").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let modal = jQuery(this).closest(".storeeez-modals");
        let buttonHtml = jQuery(form).find("button").html();
        let refresh = jQuery(this).data("refresh") ? true : false;

        let data = {
            action: 'update_influencer',
            id: jQuery(form).find("input[name='id']").val(),
            name: jQuery(form).find("input[name='name']").val(),
            email: jQuery(form).find("input[name='email']").val(),
            phonenumber: jQuery(form).find("input[name='phonenumber']").val(),
            group: jQuery(form).find("select[name='group']").val(),
            sellperiod: jQuery(form).find("select[name='sellperiod']").val()
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                jQuery("body").addClass("modal-handled");

                if (response.status == "success") {
                    /* Success Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                        </div>
                    </div>
                    `);
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                            </div>
                        </div>
                    `);
                }
            }
        });
    });

    /**
     * Edit order
     */
    jQuery(".edit-order").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let modal = jQuery(this).closest(".storeeez-modals");
        let buttonHtml = jQuery(form).find("button").html();
        let refresh = jQuery(this).data("refresh") ? true : false;

        let sales_period_id = jQuery(form).find("input[name='sales_period_id']").val();
        let order_id = jQuery(form).find("input[name='order_id']").val();

        let updated_data = {}

        let order_data = {
            name: jQuery(form).find("input[name='name']").val(),
            email: jQuery(form).find("input[name='email']").val(),
            phone_number: jQuery(form).find("input[name='phone']").val(),
            address: jQuery(form).find("input[name='address']").val()
        }

        let product_data = [];

        jQuery(form).find(".cart-item").each(function () {
            let quantity = jQuery(this).find("input[name='quantity']").val();
            if (!quantity || quantity < 1) {
                return;
            }
            product_data.push({
                product_id: jQuery(this).find("input[name='product_id']").val(),
                qty: quantity,
            });
        });


        updated_data.order_data = order_data;
        updated_data.product_data = product_data;        

        let data = {
            action: 'update_influencer_order',
            sales_period_id: sales_period_id,
            order_id: order_id,
            updated_data: updated_data
        }


        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button.submit").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
        `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                jQuery("body").addClass("modal-handled");

                if (response.status == "success") {
                    /* Success Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                        </div>
                    </div>
                    `);
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                            </div>
                        </div>
                    `);
                }
            }
        });
    });
    
    /**
     * Edit period influencer order
     * Used in /app/management/manage-period 
     */
    jQuery(".edit-period-influencer-order").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let sales_period_id = jQuery(form).find("input[name='sales_period_id']").val();
        let seller_id = jQuery(form).find("input[name='seller_id']").val();
        let updatedOrder = [];
        let newOrderProducts = [];
        let order_id_master = jQuery(this).find("input[name='order_id_master']").val();
        let newOrderName = jQuery(form).find(".appending-new-order input[name='name']").val()?.trim() ?? "";
        let newOrderVisible = jQuery(form).find(".appending-new-order").is(":visible");
        
        jQuery(form).find('.append-wrapper').each(function() {
            jQuery(this).find(".new-order-cart").each(function() {
                let order_id = jQuery(this).find("input[name='order_id']").val();
                if (!order_id) {
                    return;
                }

                let productId = jQuery(this).find("input[name='product_id']").val() ?? jQuery(this).find("select[name='product_id']").val();
                let quantity = jQuery(this).find("input[name='quantity']").val();

                let orderItem = {
                    product_id: productId,
                    quantity: quantity,
                    order_id: order_id
                }

                updatedOrder.push(orderItem);
            });
        });

        if (newOrderVisible) {
            jQuery(form).find(".appending-new-order .new-order-cart").each(function() {
                let productId = jQuery(this).find("select[name='product_id']").val() ?? jQuery(this).find("input[name='product_id']").val();
                let quantity = parseInt(jQuery(this).find("input[name='quantity']").val(), 10) || 0;

                if (!productId || quantity < 1) {
                    return;
                }

                newOrderProducts.push({
                    product_id: productId,
                    qty: quantity
                });
            });
        }

        if (newOrderVisible && (!newOrderName || newOrderProducts.length === 0)) {
            alert("Du måste ange namn och minst en produkt för den nya beställningen.");
            return;
        }

        if (updatedOrder.length === 0 && newOrderProducts.length === 0) {
            alert("Det finns ingen beställning att spara.");
            return;
        }

        let updateData = {
            action: 'update_influencer_order_multiple',
            sales_period_id: sales_period_id,
            order_id: order_id_master,
            updated_data: updatedOrder,
        }

        let createData = {
            action: 'create_management_influencer_order',
            sales_period_id: sales_period_id,
            seller_id: seller_id,
            name: newOrderName,
            products: newOrderProducts
        }

        function renderResponse(response) {
            jQuery("body").addClass("modal-handled");

            if (response.status == "success") {
                jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                if (response.total_quantity !== undefined) {
                    jQuery(form).parent().parent().find('.ajax-quantity').html(response.total_quantity);
                }
                if (response.total_value !== undefined) {
                    jQuery(form).parent().parent().find('.ajax-value').html(response.total_value);
                }
                if (response.total_profit !== undefined) {
                    jQuery(form).parent().parent().find('.ajax-profit').html(response.total_profit);
                }
                jQuery(form).addClass("flex items-center justify-center").append(`
                <div class="w-full text-center">
                    <h3 class="text-base">` + response.message + `</h3>
                    <div class="mt-6">
                        <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                    </div>
                </div>
                `);
            } else {
                jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                        </div>
                    </div>
                `);
            }
        }

        function renderError() {
            renderResponse({
                status: 'error',
                message: 'Kunde inte uppdatera order'
            });
        }

        function createNewOrder() {
            jQuery.ajax({
                url: my_ajax_object.ajax_url,
                type: 'POST',
                data: createData,
                success: function (response) {
                    renderResponse(response);
                },
                error: function () {
                    renderError();
                }
            });
        }

        function updateExistingOrders() {
            jQuery.ajax({
                url: my_ajax_object.ajax_url,
                type: 'POST',
                data: updateData,
                success: function (response) {
                    if (response.status !== "success") {
                        renderResponse(response);
                        return;
                    }

                    if (newOrderProducts.length > 0) {
                        createNewOrder();
                        return;
                    }

                    renderResponse(response);
                },
                error: function () {
                    renderError();
                }
            });
        }

        jQuery(form).addClass("opacity-50 pointer-events-none").find("button.submit").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
        `);

        if (updatedOrder.length > 0) {
            updateExistingOrders();
        } else {
            createNewOrder();
        }
    });

    /**
     * Edit group
     */

    jQuery(".edit-group").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let influencers = [];
        let modal = jQuery(this).closest(".storeeez-modals");
        let buttonHtml = jQuery(form).find("button").html();
        let refresh = jQuery(this).data("refresh") ? true : false;
        let hasPartialNewSeller = false;

        jQuery(form).find(".append-new-seller .seller-form").each(function () {
            let name = jQuery(this).find("input[name='influencers_name']").val().trim();
            let email = jQuery(this).find("input[name='influencers_email']").val().trim();
            let phonenumber = jQuery(this).find("input[name='influencers_phonenumber']").val().trim();
            let hasAnyValue = name !== "" || email !== "" || phonenumber !== "";
            let hasAllValues = name !== "" && email !== "" && phonenumber !== "";

            if (hasAnyValue && !hasAllValues) {
                hasPartialNewSeller = true;
            }
        });

        if (hasPartialNewSeller) {
            alert("Du måste fylla i alla fält för varje säljare.");
            return;
        }

        jQuery(form).find(".seller-form").each(function () {
            let name = jQuery(this).find("input[name='influencers_name']").val().trim();
            let email = jQuery(this).find("input[name='influencers_email']").val().trim();
            let phonenumber = jQuery(this).find("input[name='influencers_phonenumber']").val().trim();

            if (name === "" && email === "" && phonenumber === "") {
                return;
            }

            influencers.push({
                name: name,
                email: email,
                phonenumber: phonenumber
            });
        });

        let data = {
            action: 'update_group',
            group_id: jQuery(form).find("input[name='group_id']").val(),
            name: jQuery(form).find("input[name='name']").val(),
            influencers: influencers
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                jQuery("body").addClass("modal-handled");

                if (response.status == "success") {
                    /* Success Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                            </div>
                        </div>
                    `);
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                            </div>
                        </div>
                    `);
                }
            }
        });
    });

    /**
     * Create new group
     */

    jQuery("#create-group").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let influencers = [];
        let modal = jQuery(this).closest(".storeeez-modals");
        let buttonHtml = jQuery(form).find("button").html();
        let refresh = jQuery(this).data("refresh") ? true : false;

        jQuery(form).find(".seller-form").each(function () {
            influencers.push({
                name: jQuery(this).find("input[name='influencers_name']").val(),
                email: jQuery(this).find("input[name='influencers_email']").val(),
                phonenumber: jQuery(this).find("input[name='influencers_phonenumber']").val()
            });
        });


        let data = {
            action: 'create_group',
            name: jQuery(form).find("input[name='name']").val(),
            influencers: influencers
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.status == "success") {
                    if (response.response.group_id) {
                        /* Success Message */
                        hideModal(modal, resetModal);
                        jQuery(form).removeClass("opacity-50 pointer-events-none").find("button").removeClass("!bg-transparent").html(buttonHtml);

                        if (refresh) {
                            location.reload();
                        }

                        jQuery("#create-period").find("input[type='radio'][name='group']").prop('checked', false);

                        jQuery("#create-period").find("#groups").append(`
                        <div class="flex items-center">
                            <input type="radio" name="group" id="group-` + response.response.group_id + `" value="` + response.response.group_id + `" checked>
                            <label for="group-` + response.response.group_id + `">` + response.response.group_name + `</label>
                        </div>
                        `);
                    }
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Ladda om sidan</a>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });


    /**
     * Submit new period
     */

    jQuery("#create-period").submit(function (e) {
        formChanges = false;
        e.preventDefault();

        let form = jQuery(this);

        // if no group has been created, show error
        if (jQuery(form).find("input[type='radio'][name='group']").length === 0) {
            alert("Skapa en grupp för att starta en försäljning.");
            return;
        }

        /* ajax method here - we are using ajax? */
        let data = {
            action: 'create_sales_period',
            product_categories: jQuery(form).find("select[name='product_categories']").val(),
            sales_period: jQuery(form).find("select[name='sales_period']").val(),
            start_date: jQuery(form).find("input[name='start_date']").val(),
            name: jQuery(form).find("input[name='name']").val(),
            group: jQuery(form).find("input[type='radio']:checked").val(),
            receiver_name: jQuery(form).find("input[name='receiver_name']").val(),
            receiver_address: jQuery(form).find("input[name='receiver_address']").val(),
            receiver_zip: jQuery(form).find("input[name='receiver_zip']").val(),
            receiver_city: jQuery(form).find("input[name='receiver_city']").val(),
            receiver_phonenumber: jQuery(form).find("input[name='receiver_phonenumber']").val(),
            invoice_name: jQuery(form).find("input[name='invoice_name']").val(),
            invoice_address: jQuery(form).find("input[name='invoice_address']").val(),
            invoice_zip: jQuery(form).find("input[name='invoice_zip']").val(),
            invoice_city: jQuery(form).find("input[name='invoice_city']").val(),
            invoice_phonenumber: jQuery(form).find("input[name='invoice_phonenumber']").val(),
            invoice_email: jQuery(form).find("input[name='invoice_email']").val(),
        }

        /* Loader */
        jQuery(form).find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                /* Success Message */
                jQuery(form).html("").css("min-height", "320px");
                jQuery(form).addClass("flex items-center justify-center").append(`
                <div id="form-message">
                    ` + icons.check + `
                    <h3 class="text-2xl font-bold text-left">Försäljning '` + data.name + `' sparad</h3>
                    <div class="flex justify-end mt-6">
                        <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Starta en ny försäljning</a>
                    </div>
                </div>
                `);
                jQuery('html, body').animate({
                    scrollTop: jQuery("#create-period").offset().top - 300
                }, 300);
            }
        });
    });

    /**
     * Delete period
     */

    jQuery(".delete-period").click(function () {
        let id = jQuery(this).data("id");
        let modal = jQuery(this).closest(".storeeez-modals");
        let form = jQuery(this).closest("form");
        let refresh = jQuery(this).data("refresh") ? true : false;

        let data = {
            action: 'delete_sales_period',
            id: id
        }

        //Verify
        if (!confirm("Är du säker på att du vill radera denna säljperiod?")) {
            return;
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find(".delete-period").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,

            success: function (response) {
                if (response.status == "success") {
                    /* Success Message */
                    if (refresh) {
                        location.reload();
                    }
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });


    /**
     * Edit period
     */

    jQuery(".edit-period").submit(function (e) {

        e.preventDefault();
        let form = jQuery(this);

        let data = {
            action: 'update_sales_period',
            id: jQuery(form).find("input[name='id']").val(),
            product_categories: jQuery(form).find("select[name='product_categories']").val(),
            sales_period: jQuery(form).find("select[name='sales_period']").val(),
            start_date: jQuery(form).find("input[name='start_date']").val(),
            name: jQuery(form).find("input[name='name']").val(),
            group: jQuery(form).find("select[name='group']").val()
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `).attr("disabled", "disabled");

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                jQuery("body").addClass("modal-handled");

                if (response.status == "success") {
                    /* Success Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                        </div>
                    </div>
                    `);
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
     * Order
     */

    jQuery(".order-period").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let data = {
            action: 'create_order',
            sales_period_id: jQuery(form).find("input[name='id']").val(),
            units: jQuery(form).find("input[name='units']").val(),
            totals: jQuery(form).find("input[name='totals']").val(),
            profit: jQuery(form).find("input[name='profit']").val(),
        }

        /* Gets complete modal */
        let modal = jQuery(".storeeez-modals.modal-order-complete-" + data.sales_period_id);

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        proccessModal(form);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.status == "success") {
                    /* Success Message */
                    /* Removes current modal */
                    jQuery(form).closest(".storeeez-modals").remove();

                    /* Appends new modal */
                    jQuery(modal).removeClass("hidden");

                    /* Close modal & reload */
                    jQuery(modal).find(".close-modal").click(function () {
                        location.reload();
                    });
                } else {
                    /* Error Message */
                    jQuery(form).parent().closest(".storeeez-modals").html("").append(`
                    <div class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
       * Management Register
       */

    jQuery(".management-register").submit(function (e) {
        e.preventDefault();

        /* Resets error messages */
        jQuery(this).find(".error-holder").each(function () {
            jQuery(this).find(".no-match-error").addClass("hidden");
        });

        let form = jQuery(this);
        let buttonHtml = jQuery(form).find("button").html();

        let confirm_password = jQuery(form).find("input[name='confirm_password']").val();

        /* Check if passwords match */
        if (jQuery(form).find("input[name='password']").val() != confirm_password) {
            jQuery(form).find(".error-holder").each(function () {
                jQuery(this).find(".no-match-error").removeClass("hidden");
            });
            return;
        }

        let data = {
            action: 'create_account',
            email: jQuery(form).find("input[name='email']").val(),
            password: jQuery(form).find("input[name='password']").val(),
            firstname: jQuery(form).find("input[name='firstname']").val(),
            lastname: jQuery(form).find("input[name='lastname']").val(),
            company: jQuery(form).find("input[name='company']").val(),
            address: jQuery(form).find("input[name='address']").val(),
            zip: jQuery(form).find("input[name='zip']").val(),
            city: jQuery(form).find("input[name='city']").val(),
            phonenumber: jQuery(form).find("input[name='phonenumber']").val() ?? "", // Optional.
            gdpr: jQuery(form).find("input[name='gdpr']").is(":checked"),
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                if (response.status == "success") {
                    /* Success */
                    let redirect_url = response.redirection;

                    if (redirect_url) {
                        window.location.href = redirect_url;
                    }
                } else {
                    /* Error Message */
                    jQuery(form).hide();
                    jQuery(form).parent().append(`
                    <div id="register-error" class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <button class="btn uppercase" id="retry-register">Försök igen</button>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
     * Management Upgrade (become a responsible user)
     */

    jQuery(".management-upgrade").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let buttonHtml = jQuery(form).find("button").html();

        let data = {
            action: 'upgrade_to_responsible_user',
            security: jQuery(form).find("input[name='security']").val(),
            company: jQuery(form).find("input[name='company']").val(),
            address: jQuery(form).find("input[name='address']").val(),
            zip: jQuery(form).find("input[name='zip']").val(),
            city: jQuery(form).find("input[name='city']").val(),
            phonenumber: jQuery(form).find("input[name='phonenumber']").val() ?? "",
            gdpr: jQuery(form).find("input[name='gdpr']").is(":checked"),
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                if (response.status == "success") {
                    /* Success */
                    let redirect_url = response.redirection;

                    if (redirect_url) {
                        window.location.href = redirect_url;
                    }
                } else {
                    /* Error Message */
                    jQuery(form).hide();
                    jQuery(form).parent().append(`
                    <div id="register-error" class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <button class="btn uppercase" id="retry-register">Försök igen</button>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
     * Sales Register
     */

    jQuery(".sales-register").submit(function (e) {
        e.preventDefault();

        
        /* Resets error messages */
        jQuery(this).find(".error-holder").each(function () {
            jQuery(this).find(".no-match-error").addClass("hidden");
        });
        
        let form = jQuery(this);

        let confirm_password = jQuery(form).find("input[name='confirm_password']").val();

        /* Check if passwords match */
        if (jQuery(form).find("input[name='password']").val() != confirm_password) {
            jQuery(form).find(".error-holder").each(function () {
                jQuery(this).find(".no-match-error").removeClass("hidden");
            });
            return;
        }
        let buttonHtml = jQuery(form).find("button").html();

        let data = {
            action: 'create_account_influencer',
            first_name: jQuery(form).find("input[name='first_name']").val(),
            last_name: jQuery(form).find("input[name='last_name']").val(),
            password: jQuery(form).find("input[name='password']").val(),
            email: jQuery(form).find("input[name='email']").val(),
            phone: jQuery(form).find("input[name='phone']").val(),
            register_code: jQuery(form).find("input[name='register_code']").val(),
            gdpr: jQuery(form).find("input[name='gdpr']").is(":checked"),
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                if (response.status == "success") {
                    /* Success */
                    let redirect_url = response.redirection;

                    if (redirect_url) {
                        window.location.href = redirect_url;
                    }
                } else {
                    /* Error Message */
                    jQuery(form).hide();
                    jQuery(form).parent().append(`
                    <div id="register-error" class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <button class="btn uppercase" id="retry-register">Försök igen</button>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    jQuery(".sales-join").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);

        let data = {
            action: 'seller_join_period',
            user_id: jQuery(form).find("input[name='user_id']").val(),
            register_code: jQuery(form).find("input[name='register_code']").val()
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                if (response.status == "success") {
                    /* Success */
                    let redirect_url = response.redirection;

                    if (redirect_url) {
                        window.location.href = redirect_url;
                    }
                } else {
                    /* Error Message */
                    jQuery(form).hide();
                    jQuery(form).parent().append(`
                    <div id="register-error" class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <button class="btn uppercase" id="retry-register">Försök igen</button>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });

    /**
     * Forgot password
     */

    jQuery(".management-forgot-password").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let buttonHtml = jQuery(form).find("button").html();

        let data = {
            action: 'forgot_password',
            email: jQuery(form).find("input[name='email']").val()
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
        <div class='load-spin'><div></div><div></div><div></div></div>
    `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                if (response.status == "success") {
                    /* Success */
                    let redirect_url = response.redirection;

                    if (redirect_url) {
                        window.location.href = redirect_url;
                    }
                } else {
                    /* Error Message */
                    jQuery(form).hide();
                    jQuery(form).parent().append(`
                    <div id="forgot-password-error" class="w-full text-center">
                        <h3 class="text-base">` + response.message + `</h3>
                        <div class="mt-6">
                            <button class="btn uppercase" id="retry-forgot-password">Försök igen</button>
                        </div>
                    </div>
                    `);
                }
            }
        });
    });


    /**
     * Login
     */

    jQuery(".management-login").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let buttonHtml = jQuery(form).find("button").html();
        let data = {
            action: 'login',
            email: jQuery(form).find("input[name='email']").val(),
            password: jQuery(form).find("input[name='password']").val(),
            join: jQuery(form).find("input[name='join']").val()
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button").addClass("!bg-transparent").html(`
            <div class='load-spin'><div></div><div></div><div></div></div>
        `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                if (response.status == "success") {
                    /* Success */
                    let redirect_url = response.redirection;
                    if (redirect_url) {
                        window.location.href = redirect_url;
                    }

                } else {
                    /* Error Message */
                    jQuery(form).hide();
                    jQuery(form).parent().append(`
                        <div id="login-error" class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <button class="btn uppercase" id="retry-login">Försök igen</button>
                            </div>
                        </div>
                    `);
                }
            }
        });
    });

    /**
     * New order [Influencer -> modal]
     * add_order_to_sales_period
     */

    jQuery("#new-order").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let name = jQuery(form).find("input[name='name']").val();
        let email = jQuery(form).find("input[name='email']").val();
        let phone = jQuery(form).find("input[name='phone']").val();
        let address = jQuery(form).find("input[name='address']").val();
        let sales_period_id = jQuery(form).find("select[name='sales_period'] option:selected").data("sales-period");
        if (!sales_period_id) {
            sales_period_id = jQuery(form).find("input[name='sales_period']").val();
        }
        let user_id = jQuery(form).find("input[name='user_id']").val();
        let products = [];

        let refresh = jQuery(this).data("refresh") ? true : false;

        jQuery(form).find(".new-order-cart .cart-item").each(function () {
            // Check if this is a variable product
            if (jQuery(this).hasClass("variable-product")) {
                // Get variation quantities from hidden input
                const variationQuantitiesJson = jQuery(this).find(".variation-quantities").val();
                try {
                    const variationQuantities = JSON.parse(variationQuantitiesJson || "{}");

                    // Add each variation with quantity > 0 to products array
                    Object.keys(variationQuantities).forEach(function (variationId) {
                        const qty = variationQuantities[variationId];
                        if (qty > 0) {
                            products.push({
                                product_id: parseInt(variationId),
                                qty: qty
                            });
                        }
                    });
                } catch (e) {
                    console.error("Error parsing variation quantities:", e);
                }
            } else {
                // Handle simple products
                let product_id = jQuery(this).data("product-id");
                let product_quantity = jQuery(this).find("input[name='quantity']").val();

                if (product_quantity == 0) {
                    return;
                }

                products.push({
                    product_id: product_id,
                    qty: product_quantity
                });
            }
        });
        
        let data = {
            action: 'add_order_to_sales_period',
            name: name,
            email: email,
            phone_number: phone,
            address: address,
            sales_period_id: sales_period_id,
            products: products,
            user_id: user_id
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button.submit").addClass("!bg-transparent").html(`
            <div class='load-spin'><div></div><div></div><div></div></div>
        `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.status == "success") {
                    /* Success */
                    jQuery("body").addClass("modal-handled");

                    /* Success Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                            </div>
                        </div>
                    `);
                    const modal = jQuery(form).closest(".storeeez-modals");
                    const formOffset = jQuery(form).offset();
                    if (modal.length) {
                        const modalOffset = modal.offset();
                        const targetTop = formOffset.top - modalOffset.top + modal.scrollTop() - 250;
                        modal.animate({ scrollTop: targetTop }, 300);
                    } else {
                        jQuery("html, body").animate({ scrollTop: formOffset.top - 250 }, 300);
                    }
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Försök igen</a>
                            </div>
                        </div>
                    `);
                    const modal = jQuery(form).closest(".storeeez-modals");
                    const formOffset = jQuery(form).offset();
                    if (modal.length) {
                        const modalOffset = modal.offset();
                        const targetTop = formOffset.top - modalOffset.top + modal.scrollTop() - 250;
                        modal.animate({ scrollTop: targetTop }, 300);
                    } else {
                        jQuery("html, body").animate({ scrollTop: formOffset.top - 250 }, 300);
                    }
                }
            }
        });
    });

    /**
     * Delete order [Influencer -> modal]
     */

    jQuery(".delete-order").submit(function (e) {
        e.preventDefault();

        let form = jQuery(this);
        let refresh = jQuery(this).data("refresh") ? true : false;
        
        let sales_period_id = jQuery(form).find("input[name='sales_period_id']").val();
        let order_id        = jQuery(form).find("input[name='order_id']").val();

        let data = {
            action: 'remove_influencer_order',
            sales_period_id: sales_period_id,
            order_id: order_id
        }

        /* Loader */
        jQuery(form).addClass("opacity-50 pointer-events-none").find("button.submit").addClass("!bg-transparent").html(`
            <div class='load-spin'><div></div><div></div><div></div></div>
        `);

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.status == "success") {
                    /* Success */
                    jQuery("body").addClass("modal-handled");

                    /* Success Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Tillbaka</a>
                            </div>
                        </div>
                    `);
                } else {
                    /* Error Message */
                    jQuery(form).html("").removeClass("opacity-50 pointer-events-none").css("min-height", "240px");
                    jQuery(form).addClass("flex items-center justify-center").append(`
                        <div class="w-full text-center">
                            <h3 class="text-base">` + response.message + `</h3>
                            <div class="mt-6">
                                <a class="btn uppercase" href="javascript:window.location.href=window.location.href">Försök igen</a>
                            </div>
                        </div>
                    `);
                }
            }
        });
    });

    function resetModal(modal) {
        jQuery(modal).find("input").val("");

        /* Resets appended sellers */
        if(jQuery(modal).find(".append-new-seller").length > 0) {
            jQuery(modal).find(".seller-form").each(function() {
                if(jQuery(this).index() > 0) {
                    jQuery(this).remove();
                }
            });
        } 
    }

    function proccessModal(form) {
        //Disable all inputs
        jQuery(form).find("input").attr("disabled", "disabled");
        jQuery(form).find("select").attr("disabled", "disabled");
        jQuery(form).find("button").attr("disabled", "disabled");

        //Make overlay not clickable
        jQuery(".main__overlay").addClass("pointer-events-none");

        //Disable close button
        jQuery(form).closest(".storeeez-modals").find(".close-modal").addClass("pointer-events-none");

        //Disable escape key
        jQuery(document).unbind("keyup");
    }

    function hideModal(modal, resetModal) {
        jQuery(modal).addClass("hidden");
        jQuery("body").removeClass("modal-show");
        jQuery(".main__overlay").addClass("hidden");

        if(resetModal) {
            resetModal(modal);
        }

        /**
         * Reload page on overlay click when form is submitted
         */
        if(jQuery("body").hasClass("modal-handled")) {
            location.reload();
        }
    }

    jQuery(".bg-update").blur(function () {
        var objectId = jQuery(this).data("id");
        var objectType = jQuery(this).data("type");
        var field = jQuery(this).data("field");
        var newValue = jQuery(this).val();

        data = {
            action: 'update_object_field',
            id: objectId,
            type: objectType,
            field: field,
            new_value: newValue
        };

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {

                /* if (response.status != "success") {
                    console.log('errpr');
                } */
            }
        });
    });
}
